var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('form-component',{attrs:{"subcategories":_vm.subcategories,"delivery-method":_vm.deliveryMethod,"preview":_vm.preview},on:{"onSubmit":_vm.onSubmit,"fetchByLocale":_vm.fetchDeliveryMethod}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }